export enum Role {
    SuperUser = 1
    ,Owner
    ,Admin
    ,Registered
    ,Client
    ,UnAuthenticated
}


// WEBPACK FOOTER //
// ./src/app/shared/models/role.ts